import { render, staticRenderFns } from "./temp1.vue?vue&type=template&id=3806dd86&scoped=true"
import script from "./temp1.vue?vue&type=script&lang=js"
export * from "./temp1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3806dd86",
  null
  
)

export default component.exports